import { Link as RRDLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

export const linkBase = css`
    display: inline-flex;
    align-items: center;
    gap: ${size(1)};
    text-decoration: none;
    color: var(--c-link);
    font-size: inherit;
    font-weight: var(--font-weight-link);

    &:hover {
        text-decoration: underline;
    }
`;

interface LinkProps {
  $hoverGhost?: boolean;
  $currentColor?: boolean;
  $hasContent?: boolean;
  $valign?: 'baseline';
  $noExternalIcon?: boolean;
  $block?: boolean;
}

export const Link = styled.a.withConfig({ componentId: 'sc-13p5lnv-0' })<LinkProps>`
    ${linkBase}

    ${({ $noExternalIcon }) =>
      !$noExternalIcon &&
      css`
            // Add external link icon to external links
            &[target="_blank"] {
                &::after {
                    content: "";
                    mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M16 14.9c0 .6-.5 1.1-1.1 1.1H1.1C.5 16 0 15.5 0 14.9V1.1C0 .5.5 0 1.1 0c.6 0 1.1.5 1.1 1.1v12.6h12.6c.7 0 1.2.5 1.2 1.2zM14.9 0h-8v2.3h5.2l-6 6L7.7 10l6-6v5.2H16v-8c0-.7-.5-1.2-1.1-1.2z"/></svg>');
                    mask-size: 100%;
                    content: "";
                    display: inline-block;
                    vertical-align: baseline;
                    width: 0.75em;
                    height: 0.75em;
                    margin-left: 0.25em;
                    background-color: currentColor;
                }
            }
        `}



    ${({ $hoverGhost }) =>
      $hoverGhost &&
      css`
            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        `}

    ${({ $currentColor }) =>
      $currentColor &&
      css`
            color: currentColor;
        `}

    ${({ $hasContent }) =>
      $hasContent &&
      css`
            display: inline-flex;
            align-items: center;
        `}

    ${({ $valign }) =>
      $valign === 'baseline'
        ? css`
                  vertical-align: baseline;
              `
        : undefined}

    ${({ $block }) =>
      $block &&
      css`
            display: flex;
        `}
`;

export const RouterLink = styled(RRDLink).withConfig({ componentId: 'sc-13p5lnv-1' })<LinkProps>`
    ${linkBase}

    ${({ $hoverGhost }) =>
      $hoverGhost &&
      css`
            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        `}

  ${({ $currentColor }) =>
    $currentColor &&
    css`
            color: currentColor;
        `}

    ${({ $hasContent }) =>
      $hasContent &&
      css`
            display: inline-flex;
            align-items: center;
        `}

    ${({ $valign }) =>
      $valign === 'baseline'
        ? css`
                  vertical-align: baseline;
              `
        : undefined}

    ${({ $block }) =>
      $block &&
      css`
            display: flex;
        `}
`;
